import { useCurrentFrame, interpolate, useVideoConfig, AbsoluteFill } from "remotion";

// Variant 4 — Saffron/orange flame flicker (devotional)
function seededRand(seed: number) { const x = Math.sin(seed*127.1+311.7)*43758.5453; return x - Math.floor(x); }
export const ReelCTA4: React.FC = () => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  const fadeIn  = interpolate(frame, [0, 5], [0, 1], { extrapolateRight: "clamp" });
  const fadeOut = interpolate(frame, [Math.round(fps*2.5), Math.round(fps*3)], [1, 0], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });
  let flicker = 0.87 + Math.sin(frame * 4.4) * 0.09;
  if (seededRand(frame*13+7) < 0.06) flicker *= 0.2;
  const glow = 14 + Math.sin(frame * 3.2) * 5;
  const opacity = fadeIn * fadeOut * Math.max(0, flicker);
  return (
    <AbsoluteFill style={{ pointerEvents: "none" }}>
      <div style={{ position:"absolute", bottom:"18%", left:"50%", transform:"translateX(-50%)", opacity, whiteSpace:"nowrap" }}>
        <div style={{ background:"rgba(0,0,0,0.68)", borderRadius:7, padding:"9px 20px", border:"1px solid rgba(255,120,0,0.55)", display:"flex", alignItems:"center", gap:9, boxShadow:`0 0 ${glow}px rgba(255,90,0,0.45)` }}>
          <svg width="14" height="12" viewBox="0 0 18 14"><polygon points="0,0 18,7 0,14" fill="rgba(255,100,0,0.95)" /></svg>
          <span style={{ color:"#ffffff", fontSize:27, fontWeight:900, fontFamily:"'Arial Black','Impact',sans-serif", letterSpacing:"0.06em", textShadow:[`0 0 ${glow}px #FF6200`,`0 0 ${glow*2}px rgba(255,98,0,0.45)`,"0 2px 6px rgba(0,0,0,0.9)"].join(",") }}>WATCH FULL VIDEO</span>
        </div>
      </div>
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
